import React, { useState } from 'react';
import { createRoot } from 'react-dom/client';
import Select from 'react-select';

export default function SalesManualInputBrandSelect({ options, selectedId }) {
  const selectOptions = options.map(({ id, name }) => ({ value: id, label: name }));
  const [selected, setSelected] = useState(
    selectOptions.find((option) => String(option.value) === String(selectedId)) || null
  );

  return (
    <>
      <Select
        classNamePrefix="brand-select"
        options={selectOptions}
        value={selected}
        onChange={setSelected}
        placeholder="Select Brand"
        isClearable
        autoFocus
      />
      <input type="hidden" name="division_id" id="brands-field" value={selected?.value || ''} />
    </>
  );
}

const element = document.getElementById('sales-manual-input-brand-select');
if (element) {
  const options = JSON.parse(element.dataset.options || '[]');
  const selectedId = element.dataset.selected || '';
  const root = createRoot(element);
  root.render(<SalesManualInputBrandSelect options={options} selectedId={selectedId} />);
}
